import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Cms } from '@impact/data';

@Component({
    selector: 'app-usp',
    template: `
        <section class="usp">
            <ul class="usp__items">
                <li class="usp-item" *ngFor="let item of items">
                    <img
                        *ngIf="item.icon"
                        [src]="item.icon.src | resolveMediaUrl: { format: 'webp', width: 50 }"
                        class="usp-item__icon"
                        loading="lazy"
                        width="50"
                        height="50"
                        [alt]="item.title"
                    />
                    <div>
                        <h6 class="usp-item__heading" *ngIf="item.title">{{ item.title }}</h6>
                        <div class="usp-item__text" *ngIf="item.text">{{ item.text }}</div>
                    </div>
                </li>
            </ul>
        </section>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UspComponent {
    @Input() items?: Cms.USPItem[];
}
